class CbReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-cb-track-viewport]');
    this.track = this.querySelector('[data-cb-track]');
    this.slides = Array.from(this.querySelectorAll('[data-cb-slide]'));
    this.dotsContainer = this.querySelector('[data-cb-dots]');
    this.prevBtn = this.querySelector('[data-cb-prev]');
    this.nextBtn = this.querySelector('[data-cb-next]');

    if (!this.viewport || !this.track || this.slides.length === 0) return;

    this.index = 0;
    this.autoplayMs = 5500;
    this.autoplayTimer = null;

    this.buildDots();
    this.bindEvents();
    this.goTo(0, false);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this._onScroll?.cancel?.();
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1));

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    let scrollTimeout;
    this.viewport.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.syncFromScroll(), 80);
      },
      { passive: true }
    );

    window.addEventListener('resize', () => this.goTo(this.index, false));
  }

  buildDots() {
    if (!this.dotsContainer) return;
    this.dotsContainer.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cb-reviews-carousel__dot';
      dot.setAttribute('aria-label', `Review ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsContainer.appendChild(dot);
    });
    this.dots = Array.from(this.dotsContainer.children);
  }

  syncFromScroll() {
    const left = this.viewport.scrollLeft;
    let closest = 0;
    let minDist = Infinity;
    this.slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft - left);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });
    if (closest !== this.index) {
      this.index = closest;
      this.updateUi();
    }
  }

  goTo(target, smooth = true) {
    const len = this.slides.length;
    this.index = ((target % len) + len) % len;
    const slide = this.slides[this.index];
    this.viewport.scrollTo({
      left: slide.offsetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
    this.updateUi();
  }

  updateUi() {
    this.slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });
    this.dots?.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }

  startAutoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      const next = this.index >= this.slides.length - 1 ? 0 : this.index + 1;
      this.goTo(next);
    }, this.autoplayMs);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('cb-reviews-carousel')) {
  customElements.define('cb-reviews-carousel', CbReviewsCarousel);
}
